import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { HashRouter, Route, Switch,  Link} from 'react-router-dom';
import { BrowserRouter } from 'react-router-dom'
import StudentLogin from './StudentLogin';
import StaffLogin from './StaffLogin';
import LecturerLogin from './LecturerLogin';
import Student from './Student';
import Staff from './Staff';
import Lecturer from './Lecturer';
import PrivacyPolicy from './PrivacyPolicy';


class Approot extends Component {

   constructor(props) {
    super(props);

    this.updateStudentDetails = this.updateStudentDetails.bind(this);
    this.updateStaffDetails = this.updateStaffDetails.bind(this);
    this.updateLecturerDetails = this.updateLecturerDetails.bind(this);
    this.renderInThousands = this.renderInThousands.bind(this);

     this.state={
       user_details:{},
       user_token:"",
       student_details:{},
       staff_details:{},
       lecturer_details:{},
       loginStatus: false,
       //production parameters
       //base_url:"http://197.248.117.226:3080",
       base_url:"https://938e3d30.ngrok.io",
        portal_base_url:"https://tuc-portal.netlify.com",

       //development parameters
       //base_url:"http://localhost:3080",
       //portal_base_url:"http://localhost:3000"

    }
  }



  updateStudentDetails(studentData, loginStatus) {

    console.log("updating student data");
    this.setState({student_details:studentData, loginStatus: loginStatus});
  }

  updateStaffDetails(staffData, loginStatus) {

    console.log("updating staff data");
    this.setState({staff_details:staffData, loginStatus: loginStatus});
  }

  updateLecturerDetails(LecturerData, loginStatus) {

    console.log("updating staff data");
    this.setState({lecturer_details:LecturerData, loginStatus: loginStatus});
  }

  renderInThousands(num)
  {
    let num_parts = num.toString().split(".");
    num_parts[0] = num_parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return num_parts.join(".");
  }


  render() {

    const _this = this;


    return (
      <BrowserRouter>
          <Switch>
              <Route  exact path="/"
                      render={(props) => <StudentLogin {...props}
                                                                base_url={_this.state.base_url}
                                                                portal_base_url={_this.state.portal_base_url}
                                                                loginStatus = {this.state.loginStatus}
                                                                updateStudentDetails={_this.updateStudentDetails.bind(_this)}/>}
              />

              <Route  path="/student"
                      render={(props) => <StudentLogin {...props}
                                                                base_url={_this.state.base_url}
                                                                portal_base_url={_this.state.portal_base_url}
                                                                loginStatus= {this.state.loginStatus}
                                                                updateStudentDetails={_this.updateStudentDetails.bind(_this)} />}
              />
              <Route
                    path="/student_ui"
                    render={(props) => <Student {...props}
                                                          base_url={_this.state.base_url}
                                                          renderInThousands = {_this.renderInThousands.bind(_this)}
                                                          portal_base_url={_this.state.portal_base_url}
                                                          loginStatus= {this.state.loginStatus}
                                                          student_details = {_this.state.student_details}
                                                          updateStudentDetails={_this.updateStudentDetails.bind(_this)}/>}
              />

              <Route  path="/staff"
                      render={(props) => <StaffLogin {...props}
                                                                base_url={_this.state.base_url}
                                                                portal_base_url={_this.state.portal_base_url}
                                                                loginStatus= {this.state.loginStatus}
                                                                updateStaffDetails={_this.updateStaffDetails.bind(_this)} />}
              />

              <Route
                    path="/staff_ui"
                    render={(props) => <Staff {...props}
                                                          base_url={_this.state.base_url}
                                                          renderInThousands = {_this.renderInThousands.bind(_this)}
                                                          portal_base_url={_this.state.portal_base_url}
                                                          loginStatus= {this.state.loginStatus}
                                                          staff_details = {_this.state.staff_details}
                                                          updateStaffDetails={_this.updateStaffDetails.bind(_this)}/>}
              />

              <Route  path="/lecturer"
                      render={(props) => <LecturerLogin {...props}
                                                                base_url={_this.state.base_url}
                                                                portal_base_url={_this.state.portal_base_url}
                                                                loginStatus= {this.state.loginStatus}
                                                                updateLecturerDetails={_this.updateLecturerDetails.bind(_this)} />}
              />

              <Route
                    path="/lecturer_ui"
                    render={(props) => <Lecturer {...props}
                                                          base_url={_this.state.base_url}
                                                          renderInThousands = {_this.renderInThousands.bind(_this)}
                                                          portal_base_url={_this.state.portal_base_url}
                                                          loginStatus= {this.state.loginStatus}
                                                          lecturer_details = {_this.state.lecturer_details}
                                                          updateLecturerDetails={_this.updateLecturerDetails.bind(_this)}/>}
              />

              <Route
                    path="/privacy_policy"
                    render={(props) => <PrivacyPolicy/>}
              />
          </Switch>
      </BrowserRouter>

    );

  }
}



ReactDOM.render(
<Approot/>,
document.getElementById('root')
);
